import MetaTags from "../components/MetaTags";
import {
  Box,
  Flex,
  Heading,
  Text,
  SimpleGrid,
  Center,
  Button,
  Badge,
  HStack,
  VStack,
  Stack,
  Icon,
  Link,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useColorModeValue,
  Container,
} from "@chakra-ui/react";
import {
  FaRobot,
  FaUserShield,
  FaCheckCircle,
  FaTimesCircle,
  FaMinusCircle,
  FaUsers,
  FaComments,
  FaCertificate,
  FaArrowRight,
} from "react-icons/fa";
import Chatbot from "./chatbot";
import Image from "next/image";
import Footer from "../components/footer";
import Candiateimg from "../public/assets/c1.png";
import Candiateimg1 from "../public/assets/c2.png";
import Candiateimg2 from "../public/assets/c3.png";
import Candiateimg3 from "../public/assets/c4.png";
import Candiateimg4 from "../public/assets/robot.png";
import { useEffect, useState } from "react";
import Customerservicebot from "./customerservicesbot";
import ContactModal from "../components/contactModal";

// All 5 images imported
import OneTimePinAuth from "../public/assets/candidate and evaluation exclusivity.jpeg";
import OneTimePinAuth2 from "../public/assets/Onetimepinauthentication.png";
import InternationalImg from "../public/assets/international.png";
import MailSupportImg from "../public/assets/mail-support.png";
import OpenHoursImg from "../public/assets/open-24-hours.png";
import ssl from "../public/assets/SSL.png";
import DpdpImg from "../public/assets/dpta.png";



const Feature = ({ title, text, image }) => {
  return (
    <Flex direction="column" alignItems="center">
      <Center w={16} h={16} rounded="full" bg="gray.100" mb={1}>
        {image}
      </Center>
      <Text fontWeight={600} textAlign="center" fontFamily="Inter, sans-serif">
        {title}
      </Text>
      <Text color="gray.600" textAlign="center" fontFamily="Inter, sans-serif">
        {text}
      </Text>
    </Flex>
  );
};

// Enhanced component for the stats boxes
const StatsBox = ({ img, title, subtitle, isDpda }) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const hoverBorderColor = useColorModeValue("#3A56D4", "#5B73E8");
  const textColor = useColorModeValue("gray.600", "gray.300");
  
  return (
    <Box
      border="1px solid"
      borderColor={borderColor}
      borderRadius="2xl"
      p={{ base: 6, md: 8 }}
      textAlign="center"
      boxShadow="xl"
      bg={bgColor}
      _hover={{
        boxShadow: "2xl",
        transform: { base: "none", md: "translateY(-8px)" },
        borderColor: hoverBorderColor,
      }}
      transition="all 0.4s ease"
      position="relative"
      overflow="hidden"
      minH={{ base: "240px", md: "280px" }}
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "4px",
        bg: "linear-gradient(90deg, #3A56D4, #5B73E8)",
      }}
    >
      <Center mb={{ base: 4, md: 6 }}>
        <Box
          borderRadius={isDpda ? "xl" : "full"}
          p={{ base: 3, md: isDpda ? 5 : 4 }}
          bg={useColorModeValue("linear-gradient(135deg, #f7fafc, #edf2f7)", "linear-gradient(135deg, #2d3748, #4a5568)")}
          border="2px solid"
          borderColor={useColorModeValue("gray.100", "gray.600")}
        >
          <Image 
            src={img} 
            alt={title} 
            width={isDpda ? 80 : 64} 
            height={isDpda ? 80 : 64} 
          />
        </Box>
      </Center>
      <Heading 
        size={{ base: "md", md: "lg" }}
        color="#3A56D4" 
        mb={{ base: 3, md: 4 }}
        fontFamily="Inter, sans-serif"
        fontWeight="700"
      >
        {title}
      </Heading>
      {subtitle && (
        <Text 
          color={textColor}
          fontSize={{ base: "sm", md: "md" }}
          fontFamily="Inter, sans-serif"
          lineHeight="1.6"
        >
          {subtitle}
        </Text>
      )}
    </Box>
  );
};

const ServicesPage = () => {
  const bg = useColorModeValue("gray.50", "blue.800");
  const tableStripeBg = useColorModeValue("gray.50", "gray.800");
  const tableDimColor = useColorModeValue("#1A202C", "white");
  const tableCellColor = useColorModeValue("gray.700", "gray.300");
  const tableAptofyColor = useColorModeValue("gray.800", "white");
  const tableAptofyBg = useColorModeValue("rgba(58,86,212,0.06)", "rgba(91,115,232,0.12)");
  const [userType, setUserType] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleSeeDetailsClick = (type) => {
    setModalOpen(type);
  };

  useEffect(() => {
    const role = sessionStorage.getItem("userType");
    setUserType(role);
  }, []);

  // Updated stats data array with all 5 images
  const statsData = [
    {
      img: OneTimePinAuth,
      title: "Candidate And Evaluation Exclusivity",
      subtitle: "Your candidates and their evaluations are private and exclusive to you."
    },
    {
      img: OneTimePinAuth2,
      title: "One Time Pin Authentication",
      subtitle: "Enhanced security with OTP verification for seamless access"
    },
    {
      img: ssl,
      title: "SSL connection",
      subtitle: "Secure encrypted data transmission with advanced SSL/TLS protocols"
    },
    {
      img: InternationalImg,
      title: "Global Reach",
      subtitle: "Attract and Evaluate the Best Talent Globally"
    },
    {
      img: MailSupportImg,
      title: "24/7 Support",
      subtitle: "Round-the-clock customer support and dedicated assistance"
    },
    {
      img: OpenHoursImg,
      title: "Always Available",
      subtitle: "continuous service availability for all your needs"
    },
    {
      img: DpdpImg,
      title: "Digital Personal Data Protection Act 2023",
      subtitle: "DPDP Act 2023 compliant and aligned with modern data protection standards",
      isDpda: true
    }
  ];

  return (
    <>
      <MetaTags
        title="Aptofy - Leading Talent Assessment Company in India | Online Tools & Software Platform"
        description="Unlock your organisation's potential with Aptofy, India's premier talent assessment company. Explore our online tools and software platform for comprehensive candidate evaluation and seamless recruitment."
        url="https://www.aptofy.com/services"
      />

      {/* Hero Section - What We Offer */}
      <Box
        position="relative"
        overflow="hidden"
        bg={useColorModeValue("#ffffff", "#1A202C")}
        borderBottom="1px solid"
        borderColor={useColorModeValue("gray.100", "gray.700")}
        py={{ base: 10, md: 14 }}
        px={{ base: 4, md: 6 }}
      >
        <Container maxW="900px" position="relative" zIndex={1}>
          <Flex direction="column" align="center" textAlign="center">
            <Text
              fontSize={{ base: "xs", sm: "sm" }}
              fontWeight="700"
              letterSpacing="0.2em"
              textTransform="uppercase"
              color={useColorModeValue("#3A56D4", "#8FA2FF")}
              bg={useColorModeValue("rgba(58,86,212,0.08)", "rgba(143,162,255,0.12)")}
              border="1px solid"
              borderColor={useColorModeValue("rgba(58,86,212,0.2)", "rgba(143,162,255,0.25)")}
              borderRadius="full"
              px={4}
              py={1.5}
              mb={5}
            >
              Our Products &amp; Services
            </Text>
            <Heading
              as="h1"
              fontSize={{ base: "3xl", sm: "4xl", md: "5xl" }}
              color={useColorModeValue("#1A202C", "white")}
              fontFamily="Inter, sans-serif"
              fontWeight="800"
              mb={{ base: 4, md: 5 }}
              lineHeight="1.1"
              letterSpacing="-0.02em"
              px={{ base: 2, md: 0 }}
            >
              The{" "}
              <Box
                as="span"
                bgGradient="linear(135deg, #3B58D7, #5B73E8, #7C5CE8)"
                bgClip="text"
              >
                Aptofy Offerings
              </Box>
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color={useColorModeValue("gray.600", "gray.300")}
              maxW="640px"
              lineHeight="1.8"
              fontFamily="Inter, sans-serif"
              fontWeight="400"
              px={{ base: 2, md: 0 }}
            >
              Unlock your organisation&apos;s true potential with Aptofy, the AI-powered
              recruitment and assessment platform that transforms the way you attract,
              evaluate, and hire talent—across roles, domains, and geographies.
            </Text>
            <Text
              mt={{ base: 6, md: 7 }}
              fontSize={{ base: "md", sm: "lg", md: "xl" }}
              fontWeight="700"
              fontFamily="Inter, sans-serif"
              color={useColorModeValue("#2D3748", "white")}
            >
              Bias-free evaluation by AI.{" "}
              <Box as="span" color={useColorModeValue("#3A56D4", "#8FA2FF")}>
                Contextual decisions by humans.
              </Box>
            </Text>
          </Flex>
        </Container>
      </Box>

      {/* Core Model Section - Human decision-making, AI-driven evaluation */}
      <Box
        bg={useColorModeValue("white", "gray.900")}
        py={{ base: 16, md: 24 }}
        px={{ base: 4, md: 6 }}
      >
        <Container maxW="1200px">
          <Box textAlign="center" mb={{ base: 10, md: 14 }}>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              fontWeight="600"
              color={useColorModeValue("#3A56D4", "#8FA2FF")}
              textTransform="uppercase"
              letterSpacing="0.18em"
              mb={3}
            >
              Aptofy&apos;s Core Model
            </Text>
            <Heading
              as="h2"
              fontSize={{ base: "2xl", md: "4xl" }}
              fontFamily="Inter, sans-serif"
              fontWeight="800"
              color={useColorModeValue("#1A202C", "white")}
              mb={4}
              lineHeight="1.2"
            >
              Human decision-making, AI-driven evaluation
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color={useColorModeValue("gray.600", "gray.300")}
              maxW="760px"
              mx="auto"
              lineHeight="1.8"
            >
              AI removes bias and brings consistency to evaluation. Humans stay in
              control of the final call—applying context, judgment, and accountability
              where it matters most.
            </Text>
          </Box>

          {/* Two Pillars */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 6, md: 8 }} mb={{ base: 12, md: 16 }}>
            {/* Pillar 1 - AI = Bias-Free Evaluation Engine */}
            <Box
              borderRadius="3xl"
              p={{ base: 6, md: 8 }}
              bg={useColorModeValue("white", "gray.800")}
              border="1px solid"
              borderColor={useColorModeValue("rgba(58,86,212,0.16)", "gray.600")}
              boxShadow={useColorModeValue("0 16px 40px rgba(21, 34, 84, 0.12)", "xl")}
              position="relative"
              overflow="hidden"
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                bg: "linear-gradient(90deg, #3A56D4, #5B73E8)",
              }}
              _hover={{ transform: { base: "none", md: "translateY(-5px)" }, boxShadow: "2xl" }}
              transition="all 0.3s ease"
            >
              <HStack spacing={4} mb={4}>
                <Center
                  w={{ base: 12, md: 14 }}
                  h={{ base: 12, md: 14 }}
                  borderRadius="2xl"
                  bg="linear-gradient(135deg, #3A56D4, #5B73E8)"
                  flexShrink={0}
                >
                  <Icon as={FaRobot} color="white" boxSize={{ base: 6, md: 7 }} />
                </Center>
                <Box>
                  <Badge colorScheme="blue" borderRadius="full" px={3} py={1} mb={1}>
                    AI
                  </Badge>
                  <Heading as="h3" size={{ base: "md", md: "lg" }} color={useColorModeValue("#1A202C", "white")}>
                    Bias-Free Evaluation Engine
                  </Heading>
                </Box>
              </HStack>
              <Text fontSize={{ base: "sm", md: "md" }} color={useColorModeValue("gray.600", "gray.300")} lineHeight="1.8" mb={5}>
                A standardized interview flow with no interviewer variability, scored
                consistently across every candidate.
              </Text>

              <Text fontWeight="700" fontSize="sm" color={useColorModeValue("#1A202C", "white")} mb={3}>
                Multi-dimensional scoring
              </Text>
              <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={2} mb={5}>
                {[
                  "Hard skills",
                  "Soft skills",
                  "Communication",
                  "Problem-solving",
                  "Culture fit",
                ].map((item) => (
                  <HStack key={item} spacing={2} align="start">
                    <Icon as={FaCheckCircle} color="#3A56D4" boxSize={4} mt={1} />
                    <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                      {item}
                    </Text>
                  </HStack>
                ))}
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={5}>
                <Box>
                  <Text fontWeight="700" fontSize="sm" color={useColorModeValue("#1A202C", "white")} mb={2}>
                    Eliminates
                  </Text>
                  <VStack align="start" spacing={1.5}>
                    {[
                      "First-impression bias",
                      "Halo / Horns effect",
                      "Interview fatigue bias",
                    ].map((item) => (
                      <HStack key={item} spacing={2} align="start">
                        <Icon as={FaTimesCircle} color="#E53E3E" boxSize={3.5} mt={1} />
                        <Text fontSize="sm" color={useColorModeValue("gray.600", "gray.300")}>
                          {item}
                        </Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
                <Box>
                  <Text fontWeight="700" fontSize="sm" color={useColorModeValue("#1A202C", "white")} mb={2}>
                    Ensures
                  </Text>
                  <VStack align="start" spacing={1.5}>
                    {[
                      "Consistency across candidates",
                      "Auditability of decisions",
                    ].map((item) => (
                      <HStack key={item} spacing={2} align="start">
                        <Icon as={FaCheckCircle} color="#00B894" boxSize={3.5} mt={1} />
                        <Text fontSize="sm" color={useColorModeValue("gray.600", "gray.300")}>
                          {item}
                        </Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
              </SimpleGrid>
            </Box>

            {/* Pillar 2 - Human = Final Decision Authority */}
            <Box
              borderRadius="3xl"
              p={{ base: 6, md: 8 }}
              bg={useColorModeValue("white", "gray.800")}
              border="1px solid"
              borderColor={useColorModeValue("rgba(0,184,148,0.2)", "gray.600")}
              boxShadow={useColorModeValue("0 16px 40px rgba(21, 34, 84, 0.1)", "lg")}
              position="relative"
              overflow="hidden"
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                bg: "linear-gradient(90deg, #00B894, #2ECC71)",
              }}
              _hover={{ transform: { base: "none", md: "translateY(-5px)" }, boxShadow: "2xl" }}
              transition="all 0.3s ease"
            >
              <HStack spacing={4} mb={4}>
                <Center
                  w={{ base: 12, md: 14 }}
                  h={{ base: 12, md: 14 }}
                  borderRadius="2xl"
                  bg="linear-gradient(135deg, #00B894, #2ECC71)"
                  flexShrink={0}
                >
                  <Icon as={FaUserShield} color="white" boxSize={{ base: 6, md: 7 }} />
                </Center>
                <Box>
                  <Badge colorScheme="green" borderRadius="full" px={3} py={1} mb={1}>
                    Human
                  </Badge>
                  <Heading as="h3" size={{ base: "md", md: "lg" }} color={useColorModeValue("#1A202C", "white")}>
                    Final Decision Authority
                  </Heading>
                </Box>
              </HStack>
              <Text fontSize={{ base: "sm", md: "md" }} color={useColorModeValue("gray.600", "gray.300")} lineHeight="1.8" mb={5}>
                Your team makes the call—backed by structured, explainable evidence
                rather than gut feeling.
              </Text>

              <Text fontWeight="700" fontSize="sm" color={useColorModeValue("#1A202C", "white")} mb={3}>
                Reviews
              </Text>
              <VStack align="start" spacing={1.5} mb={5}>
                {[
                  "AI-generated candidate reports",
                  "Video responses & transcripts",
                  "Score breakdowns",
                ].map((item) => (
                  <HStack key={item} spacing={2} align="start">
                    <Icon as={FaCheckCircle} color="#00B894" boxSize={4} mt={1} />
                    <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                      {item}
                    </Text>
                  </HStack>
                ))}
              </VStack>

              <Text fontWeight="700" fontSize="sm" color={useColorModeValue("#1A202C", "white")} mb={3}>
                Applies
              </Text>
              <VStack align="start" spacing={1.5} mb={5}>
                {[
                  "Contextual judgment",
                  "Business priorities",
                  "Team fit nuances",
                ].map((item) => (
                  <HStack key={item} spacing={2} align="start">
                    <Icon as={FaCheckCircle} color="#00B894" boxSize={4} mt={1} />
                    <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                      {item}
                    </Text>
                  </HStack>
                ))}
              </VStack>

              <Box
                p={4}
                borderRadius="xl"
                bg={useColorModeValue("rgba(0,184,148,0.08)", "rgba(0,184,148,0.12)")}
              >
                <Text fontSize="sm" fontStyle="italic" color={useColorModeValue("gray.700", "gray.200")} lineHeight="1.7">
                  This preserves trust and accountability—especially for senior hiring.
                </Text>
              </Box>
            </Box>
          </SimpleGrid>

          {/* Why This Model Wins - Comparison Table */}
          <Box textAlign="center" mb={{ base: 6, md: 8 }}>
            <Heading
              as="h3"
              fontSize={{ base: "xl", md: "2xl" }}
              fontFamily="Inter, sans-serif"
              fontWeight="800"
              color={useColorModeValue("#1A202C", "white")}
              mb={2}
            >
              Why this model wins
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={useColorModeValue("gray.600", "gray.300")}>
              Structured and explainable—combining the consistency of AI with the
              ownership of human judgment.
            </Text>
          </Box>

          <Box
            borderRadius="2xl"
            overflow="hidden"
            border="1px solid"
            borderColor={useColorModeValue("gray.200", "gray.700")}
            boxShadow={useColorModeValue("0 16px 40px rgba(21, 34, 84, 0.1)", "lg")}
          >
            <TableContainer>
              <Table variant="simple" size={{ base: "sm", md: "md" }}>
                <Thead bg={useColorModeValue("gray.50", "gray.800")}>
                  <Tr>
                    <Th color={useColorModeValue("gray.600", "gray.300")} fontFamily="Inter, sans-serif">
                      Dimension
                    </Th>
                    <Th color={useColorModeValue("gray.600", "gray.300")} fontFamily="Inter, sans-serif">
                      Traditional
                    </Th>
                    <Th color={useColorModeValue("gray.600", "gray.300")} fontFamily="Inter, sans-serif">
                      AI-Only
                    </Th>
                    <Th
                      color="white"
                      bg="linear-gradient(135deg, #3A56D4, #5B73E8)"
                      fontFamily="Inter, sans-serif"
                    >
                      Aptofy Model
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {[
                    {
                      dimension: "Bias",
                      traditional: { label: "High", tone: "bad" },
                      aiOnly: { label: "Medium (black-box risk)", tone: "warn" },
                      aptofy: { label: "Low (structured + explainable)", tone: "good" },
                    },
                    {
                      dimension: "Consistency",
                      traditional: { label: "Low", tone: "bad" },
                      aiOnly: { label: "High", tone: "good" },
                      aptofy: { label: "High", tone: "good" },
                    },
                    {
                      dimension: "Trust",
                      traditional: { label: "High", tone: "good" },
                      aiOnly: { label: "Low", tone: "bad" },
                      aptofy: { label: "High", tone: "good" },
                    },
                    {
                      dimension: "Scalability",
                      traditional: { label: "Low", tone: "bad" },
                      aiOnly: { label: "High", tone: "good" },
                      aptofy: { label: "High", tone: "good" },
                    },
                    {
                      dimension: "Decision Ownership",
                      traditional: { label: "Human", tone: "good" },
                      aiOnly: { label: "AI", tone: "warn" },
                      aptofy: { label: "Human (controlled)", tone: "good" },
                    },
                  ].map((row, idx) => {
                    const toneIcon = {
                      good: { icon: FaCheckCircle, color: "#00B894" },
                      warn: { icon: FaMinusCircle, color: "#F39C12" },
                      bad: { icon: FaTimesCircle, color: "#E53E3E" },
                    };
                    const Cell = ({ data }) => (
                      <HStack spacing={2} align="start">
                        <Icon as={toneIcon[data.tone].icon} color={toneIcon[data.tone].color} boxSize={3.5} mt={0.5} />
                        <Text fontSize="sm" whiteSpace="normal">
                          {data.label}
                        </Text>
                      </HStack>
                    );
                    return (
                      <Tr key={row.dimension} bg={idx % 2 === 0 ? "transparent" : tableStripeBg}>
                        <Td fontWeight="700" color={tableDimColor}>
                          {row.dimension}
                        </Td>
                        <Td color={tableCellColor}>
                          <Cell data={row.traditional} />
                        </Td>
                        <Td color={tableCellColor}>
                          <Cell data={row.aiOnly} />
                        </Td>
                        <Td color={tableAptofyColor} bg={tableAptofyBg} fontWeight="600">
                          <Cell data={row.aptofy} />
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
      </Box>

      {/* Services Grid */}
      <Container maxW="1400px" py={{ base: 10, md: 14 }} px={{ base: 4, md: 6 }}>
        <Box mb={{ base: 8, md: 10 }} textAlign="center">
          <Text
            fontSize={{ base: "sm", md: "md" }}
            fontWeight="600"
            color={useColorModeValue("#3A56D4", "#8FA2FF")}
            textTransform="uppercase"
            letterSpacing="0.18em"
            mb={2}
          >
            Core Offerings
          </Text>
          <Heading
            as="h2"
            size={{ base: "lg", md: "xl" }}
            fontFamily="Inter, sans-serif"
            color={useColorModeValue("#1A202C", "white")}
            mb={3}
          >
            Flexible services to match your hiring and training strategy
          </Heading>
          <Text
            fontSize={{ base: "sm", md: "md" }}
            color={useColorModeValue("gray.600", "gray.300")}
            maxW="720px"
            mx="auto"
          >
            Choose exactly what you need—from a complete recruitment platform and expert-led
            interviews to proctored, AI-driven assessments and on-demand access to vetted
            industry specialists.
          </Text>
        </Box>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={{ base: 6, md: 8 }} alignItems="stretch">
          {/* Box 1 - ATS - Recruiter platform as a service */}
          <Box
            display="flex"
            flexDirection="column"
            h="100%"
            borderRadius="2xl"
            p={{ base: 6, md: 7 }}
            bg={useColorModeValue("white", "gray.800")}
            border="1px solid"
            borderColor={useColorModeValue("rgba(58,86,212,0.16)", "gray.600")}
            boxShadow={useColorModeValue("0 18px 45px rgba(21, 34, 84, 0.10)", "xl")}
            position="relative"
            overflow="hidden"
            _before={{
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "5px",
              bg: "linear-gradient(90deg, #3A56D4, #5B73E8)",
            }}
            _hover={{
              transform: { base: "none", md: "translateY(-6px)" },
              boxShadow: "0 28px 60px rgba(58,86,212,0.22)",
              borderColor: "#3A56D4",
            }}
            transition="all 0.3s ease"
          >
            <Flex
              align="center"
              justify="center"
              w={12}
              h={12}
              borderRadius="xl"
              mb={4}
              bg="linear-gradient(135deg, #3B58D7, #5B73E8)"
              color="white"
              boxShadow="0 8px 20px rgba(58,86,212,0.35)"
            >
              <Icon as={FaUsers} boxSize={5} />
            </Flex>
            <Badge mb={3} colorScheme="blue" borderRadius="full" px={3} py={1} w="fit-content">
              ATS
            </Badge>
            <Heading as="h3" size={{ base: "md", md: "lg" }} mb={3} color={useColorModeValue("#1A202C", "white")}>
              ATS &ndash; Recruiter Platform as a Service
            </Heading>
            <Text mb={3} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Aptofy&apos;s Applicant Tracking System (ATS) is a complete recruiter platform
              as a service that acts as your extended TA team&mdash;helping you post jobs,
              source, screen, track, and shortlist candidates that closely match each role.
            </Text>
            <Text mb={6} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              From sourcing and structured evaluations to AI-driven interviews and managing
              every candidate through the hiring pipeline, we deliver ready-to-review
              profiles&mdash;complete with interview scores, video responses, and
              transcripts, and available with or without automated offer letter
              generation&mdash;so your team can focus on final selection instead of manual
              filtering.
            </Text>
            <Button
              mt="auto"
              alignSelf="flex-start"
              color="white"
              bg="linear-gradient(135deg, #3B58D7, #5B73E8)"
              onClick={() => handleSeeDetailsClick(1)}
              _hover={{ bg: "linear-gradient(135deg, #2A46B0, #4A62D7)", transform: "translateX(2px)" }}
              size="md"
              borderRadius="xl"
              px={7}
              rightIcon={<Icon as={FaArrowRight} boxSize={3} />}
              transition="all 0.2s ease"
            >
              See Details
            </Button>
          </Box>

          {/* Box 2 - Interview as a Service (IaaS) */}
          <Box
            display="flex"
            flexDirection="column"
            h="100%"
            borderRadius="2xl"
            p={{ base: 6, md: 7 }}
            bg={useColorModeValue("white", "gray.800")}
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.600")}
            boxShadow={useColorModeValue("0 18px 45px rgba(21, 34, 84, 0.08)", "lg")}
            position="relative"
            overflow="hidden"
            _before={{
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "5px",
              bg: "linear-gradient(90deg, #7C5CE8, #5B73E8)",
            }}
            _hover={{
              transform: { base: "none", md: "translateY(-6px)" },
              boxShadow: "0 28px 60px rgba(124,92,232,0.20)",
              borderColor: "#7C5CE8",
            }}
            transition="all 0.3s ease"
          >
            <Flex
              align="center"
              justify="center"
              w={12}
              h={12}
              borderRadius="xl"
              mb={4}
              bg="linear-gradient(135deg, #7C5CE8, #5B73E8)"
              color="white"
              boxShadow="0 8px 20px rgba(124,92,232,0.35)"
            >
              <Icon as={FaComments} boxSize={5} />
            </Flex>
            <Badge mb={3} colorScheme="purple" borderRadius="full" px={3} py={1} w="fit-content">
              IaaS
            </Badge>
            <Heading as="h3" size={{ base: "md", md: "lg" }} mb={3} color={useColorModeValue("#1A202C", "white")}>
              Interview as a Service
            </Heading>
            <Text mb={3} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Offload first- and second-round interviews to Aptofy and get structured,
              unbiased evaluations for every candidate.
            </Text>
            <Text mb={3} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Using objective questions, coding challenges, and real-world scenarios, we
              assess problem-solving, communication, and core competencies at scale.
            </Text>
            <Text mb={6} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Ideal when your internal experts are busy but you still want deep, high-quality
              screening before final interviews.
            </Text>
            <Button
              mt="auto"
              alignSelf="flex-start"
              color="white"
              bg="linear-gradient(135deg, #7C5CE8, #5B73E8)"
              onClick={() => handleSeeDetailsClick(2)}
              _hover={{ bg: "linear-gradient(135deg, #6A4AD0, #4A62D7)", transform: "translateX(2px)" }}
              size="md"
              borderRadius="xl"
              px={7}
              rightIcon={<Icon as={FaArrowRight} boxSize={3} />}
              transition="all 0.2s ease"
            >
              See Details
            </Button>
          </Box>

          {/* Box 4 - Experts as a Service (EaaS) - temporarily hidden */}
          {/*
          <Box
            borderRadius="3xl"
            p={{ base: 6, md: 7 }}
            bg={useColorModeValue("white", "gray.800")}
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.600")}
            boxShadow={useColorModeValue("0 16px 40px rgba(21, 34, 84, 0.1)", "lg")}
            _hover={{
              transform: { base: "none", md: "translateY(-5px)" },
              borderColor: "#3A56D4",
            }}
            transition="all 0.3s ease"
          >
            <Badge mb={3} colorScheme="teal" borderRadius="full" px={3} py={1}>
              EaaS
            </Badge>
            <Heading as="h3" size={{ base: "md", md: "lg" }} mb={3} color={useColorModeValue("#1A202C", "white")}>
              Experts as a Service
            </Heading>
            <Text mb={3} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Access vetted domain experts for staff augmentation, outsourcing, contract-to-hire,
              or product engineering—without long hiring cycles.
            </Text>
            <Text fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Deploy flexible, high-impact professionals quickly while keeping control over
              quality and cost. This service is not cloud-based.
            </Text>
          </Box>
          */}

          {/* Box 5 - Certificate assessment and Trainings as a Service (CaaS) */}
          <Box
            display="flex"
            flexDirection="column"
            h="100%"
            borderRadius="2xl"
            p={{ base: 6, md: 7 }}
            bg={useColorModeValue("white", "gray.800")}
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.600")}
            boxShadow={useColorModeValue("0 18px 45px rgba(21, 34, 84, 0.08)", "lg")}
            position="relative"
            overflow="hidden"
            _before={{
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "5px",
              bg: "linear-gradient(90deg, #F6993F, #F2B05E)",
            }}
            _hover={{
              transform: { base: "none", md: "translateY(-6px)" },
              boxShadow: "0 28px 60px rgba(246,153,63,0.20)",
              borderColor: "#F6993F",
            }}
            transition="all 0.3s ease"
          >
            <Flex
              align="center"
              justify="center"
              w={12}
              h={12}
              borderRadius="xl"
              mb={4}
              bg="linear-gradient(135deg, #F6993F, #F2B05E)"
              color="white"
              boxShadow="0 8px 20px rgba(246,153,63,0.35)"
            >
              <Icon as={FaCertificate} boxSize={5} />
            </Flex>
            <Badge mb={3} colorScheme="orange" borderRadius="full" px={3} py={1} w="fit-content">
              CaaS
            </Badge>
            <Heading as="h3" size={{ base: "md", md: "lg" }} mb={3} color={useColorModeValue("#1A202C", "white")}>
              Certificate Assessment and Trainings as a Service
            </Heading>
            <Text mb={3} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Offer industry-aligned certifications and assessments as a managed service,
              without building your own exam infrastructure.
            </Text>
            <Text mb={3} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              We handle secure exam delivery, evaluation, and certificate generation, so your
              brand can focus on content, learners, and outcomes.
            </Text>
            <Text mb={6} fontSize="sm" lineHeight="1.8" color={useColorModeValue("gray.600", "gray.300")}>
              Elevate Your Training Institute with AI-Powered Proctored Assessments.
            </Text>
            <Button
              mt="auto"
              alignSelf="flex-start"
              color="white"
              bg="linear-gradient(135deg, #F6993F, #F2B05E)"
              onClick={() => handleSeeDetailsClick(4)}
              _hover={{ bg: "linear-gradient(135deg, #E08428, #E09B4A)", transform: "translateX(2px)" }}
              size="md"
              borderRadius="xl"
              px={7}
              rightIcon={<Icon as={FaArrowRight} boxSize={3} />}
              transition="all 0.2s ease"
            >
              See Details
            </Button>
          </Box>
        </SimpleGrid>
      </Container>

      {/* Enhanced Stats Section - The Aptofy Edge */}
      <Box
        bg={useColorModeValue("gray.50", "gray.900")}
        py={{ base: 16, md: 20 }}
      >
        <Container maxW="1400px" px={{ base: 4, md: 6 }}>
          <Box mb={{ base: 8, md: 10 }} textAlign="center">
            <Text
              fontSize={{ base: "sm", md: "md" }}
              fontWeight="600"
              color={useColorModeValue("#3A56D4", "#8FA2FF")}
              textTransform="uppercase"
              letterSpacing="0.18em"
              mb={2}
            >
              The Aptofy Edge
            </Text>
            <Heading
              as="h2"
              size={{ base: "lg", md: "xl" }}
              fontFamily="Inter, sans-serif"
              color={useColorModeValue("#1A202C", "white")}
              mb={3}
            >
              Built for trust, scale, and global reach
            </Heading>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              color={useColorModeValue("gray.600", "gray.300")}
              maxW="760px"
              mx="auto"
            >
              Enterprise-grade security, compliance with modern data protection standards,
              and a platform ready to support teams and candidates anywhere in the world.
            </Text>
          </Box>

          <SimpleGrid
            columns={[1, 2, 3]}
            spacing={{ base: 6, md: 8 }}
            justifyItems="center"
          >
            {statsData.map((stat, index) => (
              <StatsBox
                key={index}
                img={stat.img}
                title={stat.title}
                subtitle={stat.subtitle}
                isDpda={stat.isDpda}
              />
            ))}
          </SimpleGrid>
        </Container>
      </Box>

      {/* Enhanced Promise Section */}
      <Container maxW="1400px" px={{ base: 4, md: 6 }} py={{ base: 16, md: 20 }}>
        <Box 
          bg={useColorModeValue("white", "gray.800")}
          borderRadius="3xl"
          p={{ base: 8, md: 12 }}
          boxShadow="2xl"
          border="1px solid"
          borderColor={useColorModeValue("gray.100", "gray.600")}
          position="relative"
          overflow="hidden"
          _before={{
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "6px",
            bg: "linear-gradient(90deg, #3A56D4, #5B73E8)",
          }}
        >
          <Flex align="center" justify="center" direction="column">
            <Heading 
              size={{ base: "xl", md: "2xl" }}
              mb={{ base: 6, md: 8 }}
              color="#3B58D7"
              fontFamily="Inter, sans-serif"
              fontWeight="800"
              textAlign="center"
            >
              The Aptofy Promise
            </Heading>
            <Text 
              mb={{ base: 8, md: 10 }}
              fontSize={{ base: "md", md: "lg" }}
              textAlign="center"
              lineHeight="1.8"
              color={useColorModeValue("gray.600", "gray.300")}
              fontFamily="Inter, sans-serif"
              maxW="1000px"
            >
              At Aptofy, we are committed to transforming talent acquisition
              through integrity and innovation. Our AI-powered solutions ensure
              fair, unbiased, and transparent candidate assessments, enabling
              organizations to make confident hiring decisions. We provide
              precision-driven tools tailored to meet unique recruitment needs,
              saving time and costs while maintaining the highest quality. By
              enhancing human expertise with cutting-edge technology, we empower
              recruiters to focus on strategic goals, not repetitive tasks.
              Beyond just hiring, we help organizations build future-ready
              talent pipelines, ensuring long-term success in a rapidly evolving
              landscape. With Aptofy, every hiring decision becomes a step
              toward connecting exceptional talent with exceptional
              opportunities.
            </Text>
            <Link href="/signUp" passHref>
              <Button 
                bg="linear-gradient(135deg, #3B58D7, #5B73E8)"
                color="white"
                size={{ base: "lg", md: "xl" }}
                px={{ base: 8, md: 12 }}
                py={{ base: 4, md: 6 }}
                fontSize={{ base: "md", md: "lg" }}
                fontFamily="Inter, sans-serif"
                fontWeight="600"
                borderRadius="2xl"
                _hover={{
                  bg: "linear-gradient(135deg, #2A46B0, #4A62D7)",
                  transform: { base: "none", md: "translateY(-3px)" },
                  boxShadow: "xl",
                }}
                transition="all 0.3s ease"
                width={{ base: "full", sm: "auto" }}
              >
                Join Us Today
              </Button>
            </Link>
          </Flex>
        </Box>
      </Container>

      <ContactModal
        isOpen={isModalOpen}
        onClose={closeModal}
        type={isModalOpen}
      />

      {/* To show different chat bot for logged user and guest user */}
      {userType === '"candidate"' || userType === '"recruiter"' ? <Customerservicebot /> : <Chatbot />}

      <Footer />
    </>
  );
};

export default ServicesPage;